import { HiredTeacherPlacements } from "models";
import React from "react";
import { FaBriefcase, FaLocationArrow, FaStar } from "react-icons/fa";

interface HiredPlacementSecondaryInfoProps {
  /** The alum whose details should be displayed. */
  hiredPlacement: HiredTeacherPlacements;
  /** Whether the details should be shown in a row or column. */
  direction?: "row" | "column";
}

/** Reusable component to display secondary information for an alum. */
export function HiredPlacementSecondaryInfo({
  hiredPlacement,
  direction,
}: HiredPlacementSecondaryInfoProps): JSX.Element {
  const str = hiredPlacement.schoolAddress;
  const copy = str.slice();
  // eslint-disable-next-line
  const [first, ...rest] = copy.split(",");
  const remainder = rest.join(",").trim();

  function MajorFocus() {
    return (
      <span>
        <FaStar className="margin-less" size={21} color="grey" />
        Major: {hiredPlacement.major.charAt(0).toUpperCase()}
        {hiredPlacement.major.slice(1)}
      </span>
    );
  }

  return (
    <div className={`secondary-info d-flex flex-${direction || "row"}`}>
      {hiredPlacement.schoolAddress && (
        <span>
          <FaLocationArrow className="margin-less" size={21} color="grey" />
          {remainder}
        </span>
      )}

      <MajorFocus />
      {hiredPlacement.currentPosition ? (
        hiredPlacement.schoolName ? (
          <span>
            <FaBriefcase size={21} className="margin-less" color="grey" />
            {hiredPlacement.currentPosition} at {hiredPlacement.schoolName}
          </span>
        ) : (
          <span>
            <FaBriefcase size={21} className="margin-less" color="grey" />
            {hiredPlacement.currentPosition}
          </span>
        )
      ) : (
        hiredPlacement.schoolName && (
          <span>
            <FaBriefcase size={21} className="margin-less" color="grey" />
            {hiredPlacement.schoolName}
          </span>
        )
      )}
    </div>
  );
}
